import { Pipe, Injectable, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

const DEFAULT_DECIMAL_FORMAT = '1.2-2';

@Pipe({ name: 'iexChange' })
@Injectable()
export class ChangePipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: number, digits: string = DEFAULT_DECIMAL_FORMAT): string {
    const result = this.decimalPipe.transform(value, digits);
    const roundedValue: number = parseFloat(result);

    return roundedValue > 0 ? `+${result}` : result;
  }
}
